import React, { type ComponentType } from 'react';
import { styled } from '@compiled/react';
// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { ReportKey } from '../../model/types';
import { itemWidthGridUnits } from './item/styled';

export type Props = {
	Item: ComponentType<{
		reportKey: ReportKey;
	}>;
	reports: ReportKey[];
};

export const List = ({ Item, reports }: Props) => (
	<Container>
		{reports.map((key) => (
			<Item reportKey={key} key={key} />
		))}
	</Container>
);

export default List;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	maxWidth: `${gridSize * ((itemWidthGridUnits + 2) * 3)}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> *': {
		flex: '1 1 auto',
		margin: token('space.100', '8px'),
	},
});
